import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "../../common/input/Input.js";
import Button from "../../common/button/Button.js";
import { passwordResetRequest, passwordUpdateRequest } from "../../actions/auth.js";

import "./ForgotPassword.css";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      res: null,
      password: '',
      password_confirmation: '',
    };
  }

  /**
   * Change handler for input
   */
  handleChange = (text, name) => {
    this.setState({ [name]: text });
  }

  /**
   * Click handler for password reset
   */
  onResetPasswordClick = e => {
    e.preventDefault();
    if (!this.state.email) {
      alert("Please, enter a valid email and try again!");
    } else {
      this.props.passwordResetRequest(this.state.email);
    }
  }

  onUpdatePasswordClick = e => {
    e.preventDefault();
    if (this.state.password !== this.state.password_confirmation) {
      return alert("Please, make sure that password and password confirmation match!");
    }

    if (!this.state.password || !this.state.password_confirmation) {
      return alert("Both, password and password confirmation are required!");
    }

    this.props.passwordUpdateRequest(this.props.match.params.token, this.state.password, this.state.password_confirmation);
  }

  // Render Email form
  _renderEmailForm = () => {
    return (
      <div className="form">
        <h1>Reset Password</h1>
        <span className="message">Please, enter your email below and click RESET PASSWORD</span>
        <Input
          ph="Email"
          type="email"
          onChange={this.handleChange}
          name="email"
          value={this.state.email}
        />
        <Button className="btn-square btn-blue" onClick={this.onResetPasswordClick}>RESET PASSWORD</Button>
      </div>
    );
  }

  // Render password update form
  _renderNewPasswordForm = () => {
    return (
      <div className="form">
        <h1>Update Password</h1>
        <span className="message">Please, enter new password below and click UPDATE PASSWORD</span>
        <Input
          ph="Password"
          type="password"
          onChange={this.handleChange}
          name="password"
          value={this.state.password}
        />
        <Input
          ph="Password Confirmation"
          type="password"
          onChange={this.handleChange}
          name="password_confirmation"
          value={this.state.password_confirmation}
        />
        <Button className="btn-square btn-blue" onClick={this.onUpdatePasswordClick}>UPDATE PASSWORD</Button>
      </div>
    );
  }

  // Render success messsage
  _renderMessage = () => {
    return (
      <div className="form">
        <h1>Reset Password</h1>
        <span className="message">Password Reset instructions have been sent to your email!</span>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.res) {
      this.setState({ res: nextProps.res });
    }
  }

  render() {
    const stage = !this.props.match.params.token ? ((this.state.res === 'password_reset.success') ? 1 : 0) : 2
    return (
      <div className="forgot-password-container">
        {(stage === 0) && this._renderEmailForm()}
        {(stage === 1) && this._renderMessage()}
        {(stage === 2) && this._renderNewPasswordForm()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    res: state.auth.passwordResetRes
  };
};

const mapDispatchToProps = {
  passwordResetRequest,
  passwordUpdateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPassword.js